import React from 'react'
import PropTypes from 'prop-types'

import { Button } from 'semantic-ui-react'

export function ToggleCustomerSyncButton({
  isAuthenticated,
  syncButtonLoading,
  isCustomersSyncEnabled,
  toggleCustomersSync,
  syncLabel,
}) {
  if (!isAuthenticated) {
    return (
      <Button primary disabled loading={syncButtonLoading}>
        {`Enable ${syncLabel}`}
      </Button>
    )
  }

  if (!isCustomersSyncEnabled) {
    return (
      <Button
        primary
        loading={syncButtonLoading}
        disabled={syncButtonLoading}
        onClick={toggleCustomersSync}
      >
        {`Enable ${syncLabel}`}
      </Button>
    )
  }

  return (
    <Button loading={syncButtonLoading} disabled={syncButtonLoading} onClick={toggleCustomersSync}>
      {`Deactivate ${syncLabel}`}
    </Button>
  )
}

ToggleCustomerSyncButton.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  syncButtonLoading: PropTypes.bool.isRequired,
  isCustomersSyncEnabled: PropTypes.bool.isRequired,
  toggleCustomersSync: PropTypes.func.isRequired,
  syncLabel: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ToggleCustomerSyncButton.js